/* global axios */

import ApiClient from './ApiClient';

class AuditLogs extends ApiClient {
  constructor() {
    super('audit_logs', { accountScoped: true });
  }

  get({ page, since, until, user_id } = {}) {
    const params = new URLSearchParams();
    if (page) params.set('page', page);
    if (since) params.set('since', since);
    if (until) params.set('until', until);
    if (user_id) params.set('user_id', user_id);
    const query = params.toString();
    const url = query ? `${this.url}?${query}` : this.url;
    return axios.get(url);
  }
}

export default new AuditLogs();
